// extracted by mini-css-extract-plugin
export default {"filterWrapper":"CalcFilter_filterWrapper__LLmte","filter":"CalcFilter_filter__s3EBc"};